import { Ng2StateDeclaration } from '@uirouter/angular';
import { LogsComponent } from './logs.component';

export const logsState: Ng2StateDeclaration = {
    name: 'logs',
    parent: 'admin',
    url: '/logs',
    data: {
        authorities: ['ROLE_ADMIN'],
        pageTitle: 'logs.title',
    },
    views: {
        'content@': { component: LogsComponent },
    },
};



// WEBPACK FOOTER //
// ./src/app/admin/logs/logs.state.ts